import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const SeverityLevelCell = ({ claim, severityLevels, setSeverityLevels }) => {
   
    const { t } = useTranslation();

    const options = [
        { value: "1.0", label: "🟢 " + t("one") },
        { value: "0.3", label: "🟡 " + t("two") },
        { value: "0.5", label: "🟠 " + t("three") },
        { value: "0.75", label: "🟠 " + t("four") },
        { value: "0.8", label: "🟠 " + t("five") },
        { value: "0.9", label: "🔴 " + t("six") },
        { value: "1.2", label: "🔴 " + t("seven") },
        { value: "1.3", label: "🔴 " + t("eight") },
        { value: "1.5", label: "🔴 " + t("nine") },
        { value: "2.5", label: "🔥 " + t("ten") },
    ];

    const handleChange = (selectedOption) => {
        if (!claim?._id) return;
        setSeverityLevels((prev) => ({
            ...prev,
            [claim._id]: selectedOption?.value || "",
        }));
    };

    return (
        <td>
            <Select
                options={options}
                value={
                    options.find(
                        (o) => o.value === String(severityLevels[claim._id])
                    ) || null
                }

                onChange={handleChange}
                isDisabled={claim.status !== "Waiting for Admin Action"}
                placeholder={t("invoiceType.select")}
                classNamePrefix="react-select"
                menuPortalTarget={document.body}

                styles={{
                    control: (base, state) => ({
                        ...base,
                        minHeight: "32px",
                        minWidth: "125px",
                        fontSize: "14px",
                        borderRadius: "8px",
                        boxShadow: state.isFocused ? "0 0 0 1px #4f46e5" : base.boxShadow,
                        borderColor: state.isFocused ? "#4f46e5" : base.borderColor,
                        "&:hover": { borderColor: "#4f46e5" },
                    }),
                    option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        padding: "6px 12px",
                        backgroundColor: state.isSelected
                            ? "#4f46e5"
                            : state.isFocused
                                ? "#e0e7ff"
                                : "white",
                        color: state.isSelected ? "white" : "black",
                    }),
                    singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#111827", // make sure the text is visible
                    }),
                    placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#6b7280", // muted gray
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
            />
        </td>
    );
};

export default SeverityLevelCell;
